// « Garder hors connexion » : action explicite de l'utilisateur ; rien n'est mis de côté sans elle.
import { useState } from 'react';
import { CloudDownload, CloudOff } from 'lucide-react';
import { rendreDisponible, retirer, useHorsLigne, DUREE_JOURS, type ElementHorsLigne } from '../lib/horsLigne.ts';
import { Bouton, useNotifier } from './ui.tsx';

export function BoutonHorsLigne({ textes, ...props }: Omit<ElementHorsLigne, 'le'> & { textes?: { garder: string; garde: string } }) {
  const { possible, estDisponible } = useHorsLigne();
  const [envoi, setEnvoi] = useState(false);
  const notifier = useNotifier();
  if (!possible) return null;
  const actif = estDisponible(props.cle);
  const basculer = async () => {
    setEnvoi(true);
    try {
      if (actif) { await retirer(props.cle); notifier('Retiré de cet appareil.'); }
      else { await rendreDisponible(props); notifier(`Disponible hors connexion sur cet appareil pendant ${DUREE_JOURS} jours.`); }
    } catch (e: any) { notifier(e?.message ?? 'Échec de la mise hors connexion.', true); } finally { setEnvoi(false); }
  };
  return (
    <Bouton compact variante="fantome" chargement={envoi} aria-pressed={actif} icone={actif ? <CloudOff aria-hidden /> : <CloudDownload aria-hidden />} onClick={basculer}
      title={actif ? 'Retirer de cet appareil' : `Consultable sans réseau pendant ${DUREE_JOURS} jours sur cet appareil`}>
      {actif ? textes?.garde ?? 'Gardé hors connexion' : textes?.garder ?? 'Garder hors connexion'}
    </Bouton>
  );
}
